<template>
  <iCheckbox
    :value="rowProp.isChecked"
    :disabled="rowProp.isDisabled"
    @on-change="onChange"/>
</template>
<script>
export default {
  name: 'SelectCell',
  inject: ['table'],
  props: {
    row: { type: Object, required: true },
    rowProp: { type: Object, required: true },
  },
  methods: {
    onChange(value) {
      this.table.onSelectedChange(this.row, value);
    },
  },
};
</script>
